import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { bucket_url } from '../../constants/const'
import { Carousel } from "react-bootstrap";

import SliderOneImage from '../../assets/images/sliders/Slider-1.png';
import SliderMobile from '../../assets/images/dummy/SliderMobile.png';

import './heroSlider.module.css';
import useWindowSize from '../../hooks/useWindowSize';

const HeroSlider = props => {

    const [heroCarousel, setHeroCarousel] = useState(null)
    const { carousels } = useSelector(state => state.all)
    const size = useWindowSize();

    useEffect(() => {
        if (carousels && carousels.length > 0) {
            setHeroCarousel(carousels)
        }
    }, [carousels])

    return (
        <Carousel className="hero-carousal" interval={3000}>
            {heroCarousel && heroCarousel.map((item, index) => (
                <Carousel.Item key={`key_${index}`}>
                    <img className="d-block w-100" src={(size.width > 425) ? `${bucket_url}${item.image}` : `${bucket_url}${item.mobileImage}`} alt="First slide" />

                    {/* <Carousel.Caption className="d-none d-md-block" styleName="hero-caption">
              <h3>First slide label</h3>
              <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
          </Carousel.Caption> */}
                </Carousel.Item>
            ))}
        </Carousel>
    )
}

export default HeroSlider;